import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class CarouselsApi extends Api {
  constructor() {
    super('website/carousels/');
  }

  // GET all with filters
  list = (params = {}) => {
    return this.buildQuery('get', { params });
  };

  // GET one by ID
  show = (id) => {
    return this.buildQuery('get', {}, id);
  };

  // CREATE new carousel
  create = (data) => {
    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/carousels`,
      method: 'POST',
      data: data,
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // UPDATE carousel
  update = (id, data) => {
    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/carousels/${id}`,
      method: 'PUT',
      data: data,
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // DELETE carousel
  destroy = (id) => {
    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/carousels/${id}`,
      method: 'DELETE',
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // GET filters (shopping_centers, companies, etc)
  getFilters = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/filters`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default new CarouselsApi();
